import { cva } from 'class-variance-authority';

export const progressVariants = cva('bg-teal-200 relative h-2 w-full overflow-hidden rounded-full');
